import { useEffect } from 'react';

import { useQuery, useQueryClient } from '@gogame/query';

import { loadColumns } from '../sources/metrics';
import { metricsList } from './queryKeyFactory';

export const useLoadColumns = () => {
  return useQuery(metricsList(), (_, { signal }) => loadColumns({ signal }), {
    enabled: true,
    staleTime: 1000 * 60 * 5,
    cacheTime: 1000 * 60 * 5,
  });
};

export const usePrefetchLoadMetrics = () => {
  const queryClient = useQueryClient();
  useEffect(() => {
    queryClient.prefetchQuery({
      queryKey: metricsList(),
      queryFn: () => loadColumns(),
      staleTime: 1000 * 60 * 60 * 24,
      cacheTime: 1000 * 60 * 60 * 24,
      refetchOnReconnect: false,
    });
  }, []);
};
